<div class="card">
   <div class="card-header card-no-border">
     <div class="header-top">
       <h5 class="m-0">Prochain entretien</h5>
       <div class="card-header-right-icon">
         <div class="dropdown">
           <!-- <button class="btn dropdown-toggle" type="button" (click)="toggle()">Today</button> -->
           <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">Today</a><a class="dropdown-item" href="#">Tomorrow</a><a class="dropdown-item" href="#">Yesterday</a></div>
         </div>
       </div>
     </div>
   </div>
   <div class="card-body pt-0">
     <div class="schedule-container"> 
       <div id="schedulechart">
         <apx-chart [series]="timeLine.series" [chart]="timeLine.chart" [plotOptions]="timeLine.plotOptions" [dataLabels]="timeLine.dataLabels" [xaxis]="timeLine.xaxis" [yaxis]="timeLine.yaxis" [grid]="timeLine.grid" [responsive]="timeLine.responsive"></apx-chart>
       </div>
     </div>
   </div>
 </div>